// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
}

.header {
  background: linear-gradient(135deg, #D1581F 0%, #b84a1a 100%);
  color: white;
  padding: 24px 0;
  margin-bottom: 32px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.header h1 {
  color: white;
  margin: 0;
}

.header p {
  color: rgba(255, 255, 255, 0.9);
  margin: 4px 0 0 0;
}

.header-logo {
  height: 40px;
}

.text-gray-600 {
  color: #6b7280;
}

.text-gray-700 {
  color: #374151;
}

.bg-red-50 {
  background-color: #fef2f2;
}

.bg-green-50 {
  background-color: #f0fdf4;
}

.bg-blue-50 {
  background-color: #eff6ff;
}

.bg-orange-50 {
  background-color: #fff7ed;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-orange-100 {
  background-color: #fed7aa;
}

.text-orange {
  color: #D1581F;
}

.space-y-3 > * + * {
  margin-top: 12px;
}

.space-y-3 > *:first-child {
  margin-top: 0;
}

/* Custom checkbox styling */
input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #D1581F;
  cursor: pointer;
  margin-right: 0.5rem; /* 8px */
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .header {
    padding: 16px 0;
  }
  
  .header h1 {
    font-size: 20px;
  }
  
  .header p {
    font-size: 14px;
  }
}

.main-grid {
  grid-template-columns: 2fr 1fr;
  align-items: start;
}

.full-width {
  grid-column: 1 / -1;
}

.control-panel {
  position: sticky;
  top: 32px;
}

@media (max-width: 1024px) {
  .main-grid {
    grid-template-columns: 1fr;
  }
}

input[type="range"] {
  appearance: none;
  background: #e5e7eb;
  border-radius: 9999px;
  height: 8px;
  width: 100%;
}

input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  background: #D1581F;
  cursor: pointer;
}

input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  background: #D1581F;
  cursor: pointer;
}

.multi-select-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.sub-options-container {
  border-left: 2px solid #e5e7eb;
  padding-left: 1.5rem;
  margin-left: 0.75rem;
  margin-top: 0.75rem;
}

/* Landing Page Styles */
.landing-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f9fa; /* Light mode background */
  color: #212529; /* Dark text for light mode */
  text-align: center;
  padding: 1rem;
}

.landing-content {
  max-width: 800px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.landing-logo {
  height: 40px;
  margin-bottom: 2rem;
}

.landing-input {
  width: 100%;
  padding: 1rem 3.5rem 1rem 1.5rem; /* Make space for the button */
  border-radius: 9999px; /* Pill shape */
  border: 1px solid #ced4da; /* Lighter border for light mode */
  background-color: #ffffff; /* White background for input */
  color: #495057; /* Dark text for input */
  font-size: 1.125rem;
  outline: none;
  transition: border-color 0.2s;
}

.landing-input::placeholder {
  color: #adb5bd; /* Lighter placeholder text */
}

.landing-input:focus {
  border-color: var(--ag-brand-accent);
}

.landing-button {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--ag-brand-primary); /* Use brand color */
  color: white;
  border: none;
  border-radius: 9999px;
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.landing-button:hover {
  background-color: #c04f1a; /* A slightly darker orange on hover */
}

/* Style the gmp-place-autocomplete web component and its internal input */
.autocomplete-container gmp-place-autocomplete {
  width: 100%;
  --gmp-places-autocomplete-input-border-radius: 8px;
}

.autocomplete-container gmp-place-autocomplete > input {
  /* This is the selector for the input inside the shadow DOM */
  width: 100%;
  padding: 1rem 3.5rem 1rem 1.5rem !important; /* Make space for the button. !important to override web component styles. */
  border-radius: 8px !important; /* Rounded corners */
  border: 1px solid #ced4da !important; /* Lighter border for light mode */
  background-color: #ffffff !important; /* White background for input */
  color: #495057 !important; /* Dark text for input */
  font-size: 1.125rem !important;
  outline: none !important;
  transition: border-color 0.2s !important;
  box-sizing: border-box; /* Ensure padding doesn't affect final width */
}

.autocomplete-container gmp-place-autocomplete > input:focus {
  border-color: var(--ag-brand-accent) !important;
}

/* Override browser autofill styles */
.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill,
.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill:hover, 
.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill:focus, 
.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #ffffff inset !important; /* Use the input's background color */
    -webkit-text-fill-color: #495057 !important; /* Use the input's text color */
}

/* Hide the "clear" button in the Google Place Autocomplete component */
.autocomplete-container gmp-place-autocomplete::part(clear-button) {
  display: none !important;
} `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,oBAAoB,EAAE,QAAQ;AAChC;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,6BAA6B;EAC7C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC,EAAE,8BAA8B;EAChE,qBAAqB,EAAE,eAAe;EACtC,yBAAyB,EAAE,kCAAkC;EAC7D,yBAAyB,EAAE,+BAA+B;EAC1D,cAAc,EAAE,wBAAwB;EACxC,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,yCAAyC,EAAE,oBAAoB;EAC/D,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,2CAA2C,EAAE,4EAA4E;EACzH,6BAA6B,EAAE,oBAAoB;EACnD,oCAAoC,EAAE,kCAAkC;EACxE,oCAAoC,EAAE,+BAA+B;EACrE,yBAAyB,EAAE,wBAAwB;EACnD,8BAA8B;EAC9B,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB,EAAE,8CAA8C;AACxE;;AAEA;EACE,+CAA+C;AACjD;;AAEA,qCAAqC;AACrC;;;;IAII,uDAAuD,EAAE,qCAAqC;IAC9F,2CAA2C,EAAE,+BAA+B;AAChF;;AAEA,uEAAuE;AACvE;EACE,wBAAwB;AAC1B","sourcesContent":[".App {\n  min-height: 100vh;\n}\n\n.header {\n  background: linear-gradient(135deg, #D1581F 0%, #b84a1a 100%);\n  color: white;\n  padding: 24px 0;\n  margin-bottom: 32px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.header h1 {\n  color: white;\n  margin: 0;\n}\n\n.header p {\n  color: rgba(255, 255, 255, 0.9);\n  margin: 4px 0 0 0;\n}\n\n.header-logo {\n  height: 40px;\n}\n\n.text-gray-600 {\n  color: #6b7280;\n}\n\n.text-gray-700 {\n  color: #374151;\n}\n\n.bg-red-50 {\n  background-color: #fef2f2;\n}\n\n.bg-green-50 {\n  background-color: #f0fdf4;\n}\n\n.bg-blue-50 {\n  background-color: #eff6ff;\n}\n\n.bg-orange-50 {\n  background-color: #fff7ed;\n}\n\n.bg-blue-100 {\n  background-color: #dbeafe;\n}\n\n.bg-green-100 {\n  background-color: #dcfce7;\n}\n\n.bg-orange-100 {\n  background-color: #fed7aa;\n}\n\n.text-orange {\n  color: #D1581F;\n}\n\n.space-y-3 > * + * {\n  margin-top: 12px;\n}\n\n.space-y-3 > *:first-child {\n  margin-top: 0;\n}\n\n/* Custom checkbox styling */\ninput[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #D1581F;\n  cursor: pointer;\n  margin-right: 0.5rem; /* 8px */\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .header {\n    padding: 16px 0;\n  }\n  \n  .header h1 {\n    font-size: 20px;\n  }\n  \n  .header p {\n    font-size: 14px;\n  }\n}\n\n.main-grid {\n  grid-template-columns: 2fr 1fr;\n  align-items: start;\n}\n\n.full-width {\n  grid-column: 1 / -1;\n}\n\n.control-panel {\n  position: sticky;\n  top: 32px;\n}\n\n@media (max-width: 1024px) {\n  .main-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\ninput[type=\"range\"] {\n  -webkit-appearance: none;\n  appearance: none;\n  background: #e5e7eb;\n  border-radius: 9999px;\n  height: 8px;\n  width: 100%;\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 9999px;\n  background: #D1581F;\n  cursor: pointer;\n}\n\ninput[type=\"range\"]::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 9999px;\n  background: #D1581F;\n  cursor: pointer;\n}\n\n.multi-select-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.sub-options-container {\n  border-left: 2px solid #e5e7eb;\n  padding-left: 1.5rem;\n  margin-left: 0.75rem;\n  margin-top: 0.75rem;\n}\n\n/* Landing Page Styles */\n.landing-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background-color: #f8f9fa; /* Light mode background */\n  color: #212529; /* Dark text for light mode */\n  text-align: center;\n  padding: 1rem;\n}\n\n.landing-content {\n  max-width: 800px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.landing-logo {\n  height: 40px;\n  margin-bottom: 2rem;\n}\n\n.landing-input {\n  width: 100%;\n  padding: 1rem 3.5rem 1rem 1.5rem; /* Make space for the button */\n  border-radius: 9999px; /* Pill shape */\n  border: 1px solid #ced4da; /* Lighter border for light mode */\n  background-color: #ffffff; /* White background for input */\n  color: #495057; /* Dark text for input */\n  font-size: 1.125rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.landing-input::placeholder {\n  color: #adb5bd; /* Lighter placeholder text */\n}\n\n.landing-input:focus {\n  border-color: var(--ag-brand-accent);\n}\n\n.landing-button {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: var(--ag-brand-primary); /* Use brand color */\n  color: white;\n  border: none;\n  border-radius: 9999px;\n  padding: 0.6rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.landing-button:hover {\n  background-color: #c04f1a; /* A slightly darker orange on hover */\n}\n\n/* Style the gmp-place-autocomplete web component and its internal input */\n.autocomplete-container gmp-place-autocomplete {\n  width: 100%;\n  --gmp-places-autocomplete-input-border-radius: 8px;\n}\n\n.autocomplete-container gmp-place-autocomplete > input {\n  /* This is the selector for the input inside the shadow DOM */\n  width: 100%;\n  padding: 1rem 3.5rem 1rem 1.5rem !important; /* Make space for the button. !important to override web component styles. */\n  border-radius: 8px !important; /* Rounded corners */\n  border: 1px solid #ced4da !important; /* Lighter border for light mode */\n  background-color: #ffffff !important; /* White background for input */\n  color: #495057 !important; /* Dark text for input */\n  font-size: 1.125rem !important;\n  outline: none !important;\n  transition: border-color 0.2s !important;\n  box-sizing: border-box; /* Ensure padding doesn't affect final width */\n}\n\n.autocomplete-container gmp-place-autocomplete > input:focus {\n  border-color: var(--ag-brand-accent) !important;\n}\n\n/* Override browser autofill styles */\n.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill,\n.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill:hover, \n.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill:focus, \n.autocomplete-container gmp-place-autocomplete > input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 30px #ffffff inset !important; /* Use the input's background color */\n    -webkit-text-fill-color: #495057 !important; /* Use the input's text color */\n}\n\n/* Hide the \"clear\" button in the Google Place Autocomplete component */\n.autocomplete-container gmp-place-autocomplete::part(clear-button) {\n  display: none !important;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
